module.exports = __webpack_public_path__ + "static/media/image-2.533c3cfa.jpg";